export default "__VITE_ASSET__df49d002__"